// Campos do "Salvar em CSV" de pedidos. As chaves são as mesmas aceitas por pedidos/exportar no painel-api.
export const labelsCamposCsvPedido = {
  id_pedido: "Número do pedido",
  cliente: "Cliente",
  data: "Data",
  valor_total: "Valor total",
  cpf_cnpj: "CPF/CNPJ",
  telefone: "Telefone",
  situacao: "Situação do pedido",
  catalogo: "Catálogo",
  vendedor: "Vendedor",
  tabela: "Tabela de preço",
  reajuste: "Reajuste",
  razao_social: "Razão social",
  inscricao_estadual: "Inscrição Estadual",
  email: "E-mail",
  cep: "CEP",
  estado: "Estado",
  cidade: "Cidade",
  bairro: "Bairro",
  endereco: "Endereço",
  numero: "Número",
  complemento: "Complemento",
  observacao_pedido: "Observação do pedido",
  observacao_interna: "Observação interna",
};


export const labelsCamposCsvProdutos = {
  referencia: "Referência",
  descricao: "Descrição",
  variacao: "Variação",
  preco: "Preço",
  quantidade: "Quantidade",
  peso_unitario: "Peso unitário",
  peso_total: "Peso total",
  observacao_item: "Observação do item",
};

export type CampoCsvPedido =
  | keyof typeof labelsCamposCsvPedido
  | keyof typeof labelsCamposCsvProdutos;

export type LayoutCsvPedido = Record<CampoCsvPedido, boolean>;

export const localStorageKeyCsvPedidos = "layoutCsvPedidos";

// Default (todos true)
export const defaultLayoutCsvPedido = Object.fromEntries(
  [...Object.keys(labelsCamposCsvPedido), ...Object.keys(labelsCamposCsvProdutos)].map(
    (campo) => [campo, true]
  )
) as LayoutCsvPedido;

// Mescla com o default para campos novos já virem marcados
export const carregarLayoutCsvPedido = (): LayoutCsvPedido => {
  const stored = localStorage.getItem(localStorageKeyCsvPedidos);
  if (stored) {
    try {
      return { ...defaultLayoutCsvPedido, ...JSON.parse(stored) };
    } catch {
      return { ...defaultLayoutCsvPedido };
    }
  }
  return { ...defaultLayoutCsvPedido };
};

export const camposAtivosCsvPedido = (): CampoCsvPedido[] => {
  const layout = carregarLayoutCsvPedido();
  return (Object.keys(layout) as CampoCsvPedido[]).filter((campo) => layout[campo]);
};
